import { VehicleStatus } from "../dashboard/VehicleStatuses";

export function shouldTriggerWarning({
  vehicleStatus,
}: {
  vehicleStatus: VehicleStatus;
}) {
  const allUsers = Object.values(vehicleStatus.crew).flat();

  const highlightUserIds = new Set<string | number>();
  let includesInstructor = false;

  let allCdrValid = true;
  let allHcmValid = true;

  for (const user of allUsers) {
    if (user.roleId === 11) {
      includesInstructor = true;
    }

    if (user.crewLimit === null) {
      continue;
    }

    const isCdr = user.defaultRoleId === 1;
    const isHcm = user.defaultRoleId === 2;
    const includes3 = user.crewLimit.includes("3");
    const includesN = user.crewLimit.includes("N");

    // CDR-Check
    if (isCdr) {
      const cdrOk = includes3 || !includesN;
      if (!cdrOk) {
        allCdrValid = false;
      } else {
        highlightUserIds.add(user.userId);
      }
    }

    // HCM-Check
    if (isHcm) {
      const hcmOk = !includesN;
      if (!hcmOk) {
        allHcmValid = false;
      } else {
        highlightUserIds.add(user.userId);
      }
    }
  }

  const hasCdrWarning =
    allCdrValid && allUsers.some((u) => u.defaultRoleId === 1);
  const hasHcmWarning =
    allHcmValid && allUsers.some((u) => u.defaultRoleId === 2);

  return {
    highlightUserIds: Array.from(highlightUserIds),
    includesInstructor,
    hasCdrWarning,
    hasHcmWarning,
  };
}
